module.exports = __webpack_public_path__ + "static/media/special-stone-active.3d6abfd3.svg";